import React from 'react';

const AddEditExpenseCategory = () => {
  return <h2>Add Edit Expense Category</h2>;
};

export default AddEditExpenseCategory;
